export default __webpack_public_path__ + "static/media/006-hot air balloon.d63bfbe6.svg";